<template>
  <div id="app" class="govgr-layout-wrapper govgr-layout-wrapper__full-height">
    <div class="govgr-header">
      <Navbar
        :currentUser="currentUser"
        :startTimer="startTimer"
        :usersAllApplications="usersAllApplications"
        :countries="countries"
        :externalUserId="externalUserId"
        @logout="logoutEvent"
        @newApplication="newApplicationEvent"
        @newApplicationSelected="newApplicationSelectedEvent"
        @user-data-updated="handleUserDataUpdated"
      ></Navbar>
    </div>
    <div class="gov-width-container">
      <router-view
        :currentUser="currentUser"
        @userLoggedIn="userLoggedIn"
        :application="workingApplication"
        @usersAllApplications="usersAllApplicationsEvent"
        @workingApplication="workingApplicationEvent"
        @greekTeiDepartments="greekTeiDepartmentsEvent"
        :greekTeiDepartments="greekTeiDepartments"
        @greekUniversityDepartments="greekUniversityDepartmentsEvent"
        :greekUniversityDepartments="greekUniversityDepartments"
        @countries="countriesEvent"
        :countries="countries"
        @neededDocsGr="neededDocsGrEvent"
        :neededDocsGr="neededDocsGr"
        @neededDocsEn="neededDocsEnEvent"
        :neededDocsEn="neededDocsEn"
        @neededDocsIds="neededDocsIdsEvent"
        :neededDocsIds="neededDocsIds"
        @neededDocsMandatory="neededDocsMandatoryEvent"
        :neededDocsMandatory="neededDocsMandatory"
        @neededDocsInformation="neededDocsInformationEvent"
        :neededDocsInformation="neededDocsInformation"
        :neededDocsInformationGr="neededDocsInformationGr"
        :neededDocsInformationEng="neededDocsInformationEng"
        @externalUserId="externalUserIdEvent"
        :externalUserId="externalUserId"
        :startNewApp="startNewApp"
        @newApplication="newApplicationEvent"
        :fetchingNewApp="fetchingNewApp"
        @applicationFinalSavedEvent="newApplicationSelectedEvent"
        @logout="logoutEvent"
      >
      </router-view>
    </div>
    <div class="govgr-footer">
      <Foot :currentUser="currentUser" :externalUserId="externalUserId"></Foot>
    </div>
  </div>
</template>

<script>
import * as axios from 'axios'
import Navbar from '@/components/Navbar'
import Foot from '@/components/Foot'
import config from './config.js'
import JwtDecode from 'jwt-decode'

export default {
  name: 'App',
  data() {
    return {
      startTimer: false,
      fetchingNewApp: false,
      startNewApp: false,
      currentUser: '',
      usersAllApplications: [],
      workingApplication: {},
      greekTeiDepartments: [],
      greekUniversityDepartments: [],
      countries: [],
      neededDocsGr: [],
      neededDocsEn: [],
      neededDocsIds: [],
      neededDocsMandatory: [],
      neededDocsInformation: [],
      neededDocsInformationGr: [],
      neededDocsInformationEng: [],
      externalUserId: Number,
    }
  },
  computed: {},
  created() {
    if (!JSON.parse(sessionStorage.getItem('refreshed'))) {
      let token = this.readCookie('accessToken')
      console.log(token) //JwtDecode(token)
      console.log(JwtDecode(token))
      sessionStorage.setItem('token', token)
    }
    document.cookie = 'accessToken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT'
    this.checkCurrentLogin()
  },
  updated() {
    this.checkCurrentLogin()
  },
  methods: {
    readCookie(name) {
      var nameEQ = name + '='
      var ca = document.cookie.split(';')
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) === ' ') c = c.substring(1, c.length)
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
      }
      return null
    },
    handleUserDataUpdated(updatedData) {
      // Reload the working application from sessionStorage
      const applicationStr = sessionStorage.getItem('workingApplication')
      if (applicationStr) {
        try {
          this.workingApplication = JSON.parse(applicationStr)
          // Force Vue to update the reactive data
          this.$forceUpdate()
        } catch (error) {
          console.error('Error updating workingApplication:', error)
        }
      }
    },
    newApplicationSelectedEvent(appId) {
      this.fetchingNewApp = true
      axios
        .get(`${config.BASE_URL}/users/uid/applications/${appId}`)
        .then(response => {
          this.workingApplication = response.data.data
          this.neededDocsGr = []
          this.neededDocsEn = []
          this.neededDocsIds = []
          this.neededDocsMandatory = []
          this.neededDocsInformation = []
          this.neededDocsInformationGr = []
          this.neededDocsInformationEng = []
          response.data.data.neededDocuments.forEach(doc => {
            this.neededDocsGr.push(doc.grName)
            this.neededDocsEn.push(doc.engName)
            this.neededDocsIds.push(doc.id)
            this.neededDocsMandatory.push(doc.mandatory)
            this.neededDocsInformation.push(doc.information)
            this.neededDocsInformationGr.push(doc.grInformation)
            this.neededDocsInformationEng.push(doc.engInformation)
          })
          this.fetchingNewApp = false
        })
        .catch(err => {
          console.log(err)
          let tempMessage = ''
          Object.keys(err.response.data.message).forEach(key => {
            tempMessage += err.response.data.message[key].reduce(
              (acc, cur) => acc.slice(0, -1) + ', ' + cur.slice(0, -1)
            )
          })
          tempMessage = tempMessage + '.'
          this.$notify({
            title: 'Προειδοποίηση',
            message: tempMessage,
            offset: 100,
          })
        })
    },
    newApplicationEvent() {
      this.workingApplication = {}
      sessionStorage.setItem('workingApplication', {})
      this.usersAllApplications = []
      sessionStorage.setItem('usersAllApplications', [])
      this.neededDocsGr = []
      sessionStorage.setItem('neededDocsGr', [])
      this.neededDocsEn = []
      sessionStorage.setItem('neededDocsEn', [])
      this.neededDocsIds = []
      sessionStorage.setItem('neededDocsIds', [])
      this.neededDocsMandatory = []
      sessionStorage.setItem('neededDocsMandatory', [])
      this.neededDocsInformation = []
      sessionStorage.setItem('neededDocsInformation', [])
      this.neededDocsInformationGr = []
      sessionStorage.setItem('neededDocsInformationGr', [])
      this.neededDocsInformationEng = []
      sessionStorage.setItem('neededDocsInformationEng', [])
      sessionStorage.setItem('externalUserId', '')
      this.startNewApp = true
    },
    logoutEvent(user) {
      this.currentUser = null
      this.workingApplication = {}
      this.usersAllApplications = []
      this.neededDocsGr = []
      this.neededDocsEn = []
      this.neededDocsIds = []
      this.neededDocsMandatory = []
      this.neededDocsInformation = []
      this.neededDocsInformationGr = []
      this.neededDocsInformationEng = []
      this.externalUserId = ''
      this.startNewApp = false
      this.startTimer = false
      sessionStorage.clear()
    },
    externalUserIdEvent(id) {
      this.externalUserId = id
    },
    neededDocsIdsEvent(docs) {
      this.neededDocsIds = docs
    },
    neededDocsEnEvent(docs) {
      this.neededDocsEn = docs
    },
    neededDocsGrEvent(docs) {
      this.neededDocsGr = docs
    },
    neededDocsMandatoryEvent(docs) {
      this.neededDocsMandatory = docs
    },
    neededDocsInformationEvent(docs) {
      this.neededDocsInformation = docs.el
      this.neededDocsInformationGr = docs.el
      this.neededDocsInformationEng = docs.en
    },
    countriesEvent(countries) {
      this.countries = countries
    },
    greekUniversityDepartmentsEvent(greekUniversity) {
      this.greekUniversityDepartments = greekUniversity
    },
    greekTeiDepartmentsEvent(greekTei) {
      this.greekTeiDepartments = greekTei
    },
    workingApplicationEvent(app) {
      this.workingApplication = app
    },
    usersAllApplicationsEvent(allApps) {
      this.usersAllApplications = allApps
    },
    userLoggedIn(username) {
      this.startTimer = true
      sessionStorage.setItem('currentUser', JSON.stringify(username))
      this.currentUser = username
      this.$store.dispatch('SET_USER', username)
    },
    checkCurrentLogin() {
      // if (!this.currentUser && this.$route.path !== '/') {
      // sessionStorage.setItem('currentUser', '')
      // if (this.countRefreshes === 2) {
      //   this.$router.push('/')
      //   this.countRefreshes = 0
      // } else {
      //   this.$router.push(this.$route.path) // '/?redirect=' + this.$route.path
      //   this.countRefreshes += 1
      // }
      // }
    },
  },
  components: {
    Navbar,
    Foot,
  },
}
</script>

<style lang="scss">
// .el-form-item--small.el-form-item {
//   margin-bottom: 4px;
// }
// #app {
//   font-family: 'Avenir', Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   color: #2c3e50;
// }
</style>
